import React from "react";
import { useOutletContext } from "react-router-dom";
import { AccountPanel } from "@pgs-core/ui/components/account-panel";
import type { AdminOutletContext } from "../lib/outlet-context";

export function AccountPage() {
  const { user, changePassword } = useOutletContext<AdminOutletContext>();
  return <AccountPanel email={user?.email ?? ""} onChangePassword={changePassword} />;
}
